import { alpha, darken } from '@mui/material'
import { colors } from './colors.theme'

const textButtonColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        color: val,
        backgroundImage: 'none',
        '&.Mui-disabled': {
          color: alpha(val, 0.4),
        },
      },
    ]
  }),
)

const containedButtonColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        background: val,
        '&:hover': {
          background: darken(val, 0.2),
        },
        '&.Mui-disabled': {
          background: alpha(val, 0.2),
        },
      },
    ]
  }),
)

const outlinedButtonColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        borderColor: val,
        color: val,
        backgroundColor: alpha(val, 0.3),
        '&:hover': {
          backgroundColor: alpha(darken(val, 0.2), 0.3),
        },
        '&.Mui-disabled': {
          borderColor: alpha(val, 0.3),
          color: alpha(val, 0.3),
          backgroundColor: alpha(val, 0.1),
        },
      },
    ]
  }),
)

export const buttonTheme = {
  root: {
    borderRadius: 8,
    textTransform: 'capitalize' as 'capitalize',
    fontWeight: 'bold' as 'bold',
    minWidth: 100,

    '&.link': {
      color: colors.blue,
      minWidth: 0,
      padding: 0,
      textDecoration: 'underline',
      backgroundColor: 'transparent',
    },
    '&.margin-x': {
      marginLeft: 4,
      marginRight: 4,
    },
  },
  label: {
    wordBreak: 'break-word' as 'break-word',
  },
  contained: {
    background: colors.white, // main-bottom
    color: colors.black,
    border: `1px solid ${colors.white}`,
    '&.Mui-disabled': {
      background: `${alpha(colors.white, 0.5)}`,
      border: `1px solid ${alpha(colors.white, 0.1)}`,
    },
    '&:hover': {
      background: `${alpha(colors.white, 0.5)}`,
      border: `1px solid ${alpha(colors.white, 0.1)}`,
    },
    ...containedButtonColors,
  },
  containedPrimary: {
    background: colors.primary,
    color: colors.white,
    borderColor: colors.primary,
  },
  outlined: {
    '&.Mui-disabled': {
      border: `1px solid ${alpha(colors.white, 0.5)}`,
      color: colors.white,
    },
    '&:hover': {
      border: `1px solid ${colors.white}`,
      color: colors.white,
      background: colors.black,
    },
    ...outlinedButtonColors,
  },
  outlinedPrimary: {
    border: `1px solid ${colors.white}`,
    color: colors.white,
  },
  outlinedSizeSmall: {
    minWidth: 75,
  },
  text: {
    color: colors.white,
    ...textButtonColors,
  },
}
